// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3wwgy","actions":"GroupTable_actions__2fbaI","deleteModalFooter":"GroupTable_deleteModalFooter__2GWXI"};